const common = {
  hu: {
    workQuantityShort: "Db.",
    workMaterialsEmpty: "Nincsenek alapanyagok.",
    workFilesEmpty: "Nincsenek fájlok.",
    scriptsHeaderShort_id: "Azon.",
    scriptsHeaderShort_name: "Név",
    scriptsHeaderShort_room: "Hely.",
    scriptsDuplicate: "Másolás",
    modify: "Módosítás",
    clientsHeaderShort_id: "Azon.",
    clientsHeaderShort_name: "Név",
    clientsHeaderShort_clientSold: "Egy.",
    clientsHeaderShort_address: "Cím",
    employeesTableEmpty: "Nincsenek alkalmazottak.",
    employeesHeaderShort_id: "Azon.",
    employeesHeaderShort_name: "Név",
    employeesHeaderShort_email: "E-mail",
    employeesHeaderShort_username: "Felh.név",
    employeesHeaderShort_role: "Szerep",
    employeesHeaderShort_address: "Cím",
    usersTableEmpty: "Nincsenek felhasználók.",
    usersHeaderShort_id: "Azon.",
    usersHeaderShort_name: "Név",
    usersHeaderShort_email: "E-mail",
    usersHeaderShort_username: "Felh.név",
    usersHeaderShort_balance: "Egy.",
    usersHeaderShort_phone: "Tel.",
    usersHeaderShort_address: "Cím",
    worksHeaderShort_id: "Azon.",
    worksHeaderShort_client: "Kl.",
    worksHeaderShort_user: "Aszt.",
    worksHeaderShort_workName: "Munka",
    worksHeaderShort_paid: "Fiz.",
    worksHeaderShort_totalPrice: "Ár",
    worksHeaderShort_laborCost: "Díj",
    worksHeaderShort_status: "Áll.",
    worksHeaderShort_measured: "Felm.",
    worksHeaderShort_ordered: "Rend.",
    worksHeaderShort_completed: "Bef.",
    overview: "Áttekintés",
    help: "Hogyan csináld?",
    id: "Azonosító",
    name: "Név",
    exampleShort: "Pl.",
    width: "Szélesség",
    height: "Magasság",
    depth: "Mélység",
    add: "Hozzáadás",
    delete: "Törlés",
    available: "Elérhető",
    notAvailable: "Nem elérhető",
    rotatable: "Forgatható",
    notRotatable: "Nem forgatható",
    rotable: "Forgatható",
    notRotable: "Nem forgatható",
    splittable: "Darabolható",
    notSplittable: "Nem darabolható",
    none: "—",
    month: "Hónap",
    week: "Hét",
    day: "Nap",
    client: "Kliens",
    user: "Asztalos",
    paid: "Fizetve",
    totalPrice: "Teljes ár",
    laborCost: "Munkadíj",
    status: "Állapot",
    measured: "Felmért",
    ordered: "Rendelt",
    CANCELLED: "Törölve",
    completed: "Befejezett",
    Measured: "Felmért",
    Ordered: "Rendelt",
    Cancelled: "Törölve",
    Completed: "Befejezett",
    weekdays: [
      "Hétfő",
      "Kedd",
      "Szerda",
      "Csütörtök",
      "Péntek",
      "Szombat",
      "Vasárnap"
    ],
    kant: "Kant",
    colors: "Színek",
    color: "Szín",
    addColor: "Szín hozzáadása",
    image: "Kép",
    dimension: "Méret",
    material: "Anyag",
    group: "Csoport",
    price: "Ár",
    splitDimension: "Darabolt méret",
    welcome: "Üdv",
    logoutTitle: "Biztosan kilépsz?",
    logoutBody: "Ha kilépsz a nem mentett módosítások elvesznek.",
    cancel: "Mégsem",
    logout: "Kijelentkezés",
    search: "Keresés",
    noSearchResults: "Nincs találat.",
    clientSold: "Fizetendő",
    dashboard: "Kezdőlap",
    clients: "Kliensek",
    employee: "Alkalmazottak",
    users: "Felhasználók",
    noUsers: "Még nincs megjeleníthető felhasználó.",
    assignedWorkCount: "Munkák száma",
    orderedWorkCount: "Munkák",
    createWork: "Munka létrehozása",
    createClient: "Kliens létrehozása",
    createCarpenter: "Asztalos létrehozása",
    selectClient: "Válassz klienst",
    selectCarpenter: "Válassz asztalost",
    works: "Munkák",
    scripts: "Tervek",
    schedule: "Naptár",
    reports: "Kimutatások",
    settings: "Beállítások",
    save: "Mentés",
    createdItemsUndo: "Vissza",
    createdItemsSaving: "Mentés folyamatban…",
    createdItemsRedo: "Előre",
    cancelBtn: "Mégse",
    saveBtn: "Mentés",
    actions: "Műveletek",
    visible: "Látható",
    show: "Mutat",
    hide: "Elrejt",
    username: "Felhasználónév",
    email: "Email",
    address: "Cím",
    role: "Feladatkör",
    companyUser: "Céges felhasználó",
    companyAdmin: "Céges admin",
    admin: "Admin",
    userRole: "Felhasználó",
    balance: "Egyenleg",
    phone: "Telefonszám",
    filter: "Szűrés",
    filterValue: "Szűrés érték",
    sort: "Rendezés",
    selectValue: "Válassz értéket",
    filterMin: "Min",
    filterMax: "Max",
    pending: "Függőben",
    Pending: "Függőben",
    active: "Aktív",
    cancelled: "Törölve",
    quantity: "Darabszám",
    addConditional: "Elágazás hozzáadása",
    quantityExpressionPlaceholder: "Darabszám vagy képlet",
    condition: "Feltétel",
    leftValue: "Bal oldal",
    rightValue: "Jobb oldal",
    relation: "Reláció",
    whenConditionTrue: "Ha teljesül",
    whenConditionFalse: "Ha nem teljesül",
    insertableElements: "Beszúrható elemek",
    generalData: "Általános adatok",
    editName: "Név szerkesztése",
    editMaterial: "Anyag szerkesztése",
    removeConditional: "Elágazás törlése",
    keepTrueBranch: "Elágazás törlése, igaz ág megtartása",
    keepFalseBranch: "Elágazás törlése, hamis ág megtartása",
    clearExpression: "Kifejezés törlése",
    deleteToken: "Beillesztett elem törlése",
    rotationQuarterTurns: "Forgatás: 0 = 0°, 1 = 90°, 2 = 180°, 3 = 270°.",
    dimensions: "Méretek",
    position: "Pozíció",
    rotation: "Forgatás",
    noItems: "Nincsenek elemek",
    details: "Részletek",
    length: "Hosszúság",
    quantityShort: "Db",
    allColors: "Összes szín",
    noColors: "Nincsenek színek",
    millings: "Marásminták",
    preview: "Előnézet",
    download: "Letöltés",
    uploadFiles: "Fájl import",
    uploading: "Feltöltés...",
    filesUploaded: "Fájl(ok) sikeresen feltöltve.",
    uploadError: "Feltöltési hiba történt.",
    downloadError: "Letöltési hiba.",
    deleteError: "Törlési hiba.",
    confirmDelete: "Biztos törölni akarod a fájlt?",
    fileDeleted: "Fájl törölve.",
    searchPlaceholder: "Keresés... (* = bármi)",
    noColor: "- Nincs szín",
    unknownColor: "Ismeretlen szín",
    noMilling: "- Nincs marás",
    noMilling1: "Nincs marás",
    noMillingAvailable: "Nincs elérhető marás",
    manualImport: "Kézi import",
    importInProgress: "Import folyamatban...",
    cmrStats: "Statisztika",
    cmrTotalParts: "Összes elem",
    cmrUsedParts: "Felhasznált elemek",
    cmrUsedSheets: "Felhasznált táblák",
    cmrYield: "Kihasználtság",
    cmrLastYield: "Utolsó kihasználtság",
    cmrCutLength: "Vágási hossz",
    cmrBandingLength: "Élzáró hossz",
    cmrBandingByType: "Élzárás típusonként",
    cmrType: "Típus",
    cmrLengthMm: "Hossz (mm)",
    cmrSheets: "Táblák",
    cmrParts: "Alkatrészek",
    cmrComment: "Megjegyzés",
    yes: "Igen",
    no: "Nem",
    model: "Modell",
    allWorksTitle: "Munkák",
    addClient: "Kliens hozzáadása",
    toolbarMeasure: "Távolság mérés",
    toolbarSnapping: "Tapadás",
    toolbarMove: "Mozgatás (bal: XZ, jobb: fel/le)",
    toolbarRotate: "Forgatás (bal: vízszintes)",
    toolbarSizeLabelsOn: "Méret felirat (bekapcsolva)",
    toolbarSizeLabelsOff: "Méret felirat (kikapcsolva)",
    toolbarGroupingOn: "Csoportos mozgatás (bekapcsolva) [G]",
    toolbarGroupingOff: "Csoportos mozgatás (kikapcsolva) [G]",
    createdItemsTitle: "Generált elemek",
    clientsTitle: "Kliensek",
    filterByName: "Név szerint",
    filterByBalance: "Egyenleg szerint",
    filterByAddress: "Cím szerint",
    sortNameAsc: "Név (A-Z)",
    sortNameDesc: "Név (Z-A)",
    sortBalanceAsc: "Egyenleg (növekvő)",
    sortBalanceDesc: "Egyenleg (csökkenő)",
    noClients: "Nincsenek kliensek",
    rotatableShort: "Forg.",
    longEdge: "Hosszú kant",
    shortEdge: "Rövid kant",
    addNewItem: "+ Új elem hozzáadása",
    scriptItems: "Terv elemei",
    selectedCount: "{{count}} kijelölve",
    edgeType: "Kant",
    longEdgeCount: "Hossz k.",
    shortEdgeCount: "Szél k.",
    saveSuccess: "A mentés sikeresen megtörtént.",
    saveFailed: "Hiba történt a mentés során.",
    savingInProgress: "Mentés folyamatban…",
    addNewObject: "Új objektum hozzáadása",
    objects: "Objektumok",
    object: "Objektum",
    settingsTitle: "Beállítások",
    millingMaterialChangeTitle: "Anyagváltás",
    millingMaterialChangeConfirm: "Biztosan erre az anyagra váltasz?",
    millingMaterialChangeAccept: "Igen, váltás",
    allGroups: "Összes csoport",
    chooseColor: "Szín kiválasztása",
    replaceColor: "Szín cseréje",
    forgotPasswordTitle: "Elfelejtett jelszó",
    forgotPasswordSuccess:
      "Ha létezik fiók ezzel az e-mail címmel, egy visszaállító linket küldtünk.",
    forgotPasswordError: "Valami hiba történt. Kérjük, próbálja újra később.",
    forgotPasswordSubmit: "Visszaállító link küldése",
    loading: "Betöltés...",
    loginTitle: "Bejelentkezés",
    loginError: "Rossz felhasználónév vagy jelszó.",
    loginOfflineError:
      "Nincs hálózati kapcsolat, kérlek ellenőrizd az internetkapcsolatod.",
    loginOfflineWarning:
      "Offline vagy, kérlek ellenőrizd az internetkapcsolatod.",
    usernamePlaceholder: "Írd be a felhasználóneved",
    password: "Jelszó",
    passwordPlaceholder: "Írd be a jelszót",
    rememberMe: "Emlékezz rám",
    register: "Regisztráció",
    forgotPassword: "Elfelejtetted a jelszavad?",
    repeatPassword: "Jelszó megerősítése",
    registerPasswordMismatch: "A jelszavak nem egyeznek.",
    registerSuccess: "Sikeres regisztráció! Most már bejelentkezhetsz.",
    registerError: "Sikertelen regisztráció. Kérjük ellenőrizd az adatokat.",
    backToLogin: "Vissza a bejelentkezéshez",
    resetPasswordTitle: "Jelszó visszaállítása",
    resetPasswordWelcome1Error:
      'A "Welcome1" jelszó használata nem engedélyezett, kérlek válassz másikat.',
    resetPasswordMismatch: "A két jelszó nem egyezik, kérlek ellenőrizd újra.",
    resetPasswordSameAsPrevious:
      "Az új jelszó nem egyezhet meg a korábbi jelszóval.",
    resetPasswordSuccess:
      "A jelszó sikeresen megváltozott. Átirányítás a bejelentkező oldalra…",
    resetPasswordError: "Hiba történt, kérlek próbáld újra később.",
    resetPasswordSubmit: "Jelszó mentése",
    newPassword: "Új jelszó",
    newPasswordPlaceholder: "Írd be az új jelszót",
    repeatPasswordPlaceholder: "Írd be újra az új jelszót",
    saving: "Mentés…",
    millingsListTitle: "Marásminták listája",
    millingNameRequired: "A név megadása kötelező.",
    millingNamePlaceholder: "Pl. nútmarás",
    millingSaveError: "Mentési hiba.",
    noData: "Nincs adat",
    tableLabel: "Tábla",
    filterAll: "Teljes lista",
    colorSwapFailed: "A színcsere nem sikerült. Kérlek próbáld újra.",
    addItemFailed: "Nem sikerült új elemet hozzáadni, kérlek próbáld újra.",
    generatingInProgress: "Generálás folyamatban...",
    generateAlreadyOptimal: "Már optimális eredmény van.",
    generateSuccess: "Sikeres generálás.",
    saveChangesTitle: "Változtatások mentése",
    saveChangesBeforeGenerate:
      "Vannak nem mentett módosítások. Előbb elmentsem őket, majd generáljak?",
    saveAndGenerate: "Mentés & Generálás",
    noTablesYet: "Még nincs tábla, generálj először",
    addTableFailed: "Nem sikerült új táblát hozzáadni.",
    deleteTableConfirm:
      "Biztosan törölni szeretnéd ezt a táblát és az ahhoz tartozó elemeket?",
    saveChangesConfirm: "Biztosan menteni szeretnéd a változtatásokat?",
    rotateFailed: "Forgatás nem lehetséges, nincs szabad hely.",
    unsavedChangesBody:
      "Vannak nem mentett módosítások. Mentsük, mielőtt továbblépsz?",
    saveAndContinue: "Mentés & Tovább",
    discardChanges: "Elvetés & Tovább",
    editBtn: "Szerkesztés",
    exportBtn: "Exportálás",
    generateBtn: "Generálás",
    addTable: "Tábla hozzáadás",
    deleteTable: "Tábla törlése",
    moveToTable: "Áthelyezés a:",
    rotateTable: "Tábla forgatása",
    bgOff: "Háttér ki",
    bgOn: "Háttér be",
    detailsOff: "Részletek ki",
    detailsOn: "Részletek be",
    linesOff: "Vonalak ki",
    linesOn: "Vonalak be",
    tableId: "Tábla azonosító",
    unknownId: "Ismeretlen azonosító",
    noTableSelected: "Nincs kiválasztott tábla",
    currentTable: "Aktuális tábla",
    avgUsage: "Átlagos kihasználtság",
    partCount: "Darabszám",
    measureCount: "Méretek száma",
    kantTotal: "Kant összesen",
    usage: "Kihasználtság",
    noSize: "Nincs méret",
    posX: "Jobbra-Balra",
    posY: "Fel-Le",
    posZ: "Előre-Hátra",
    rotX: "Előre-Hátra",
    rotY: "Vízszintesen",
    rotZ: "Oldalra",
    snapInfo: "Bútor illesztés",
    snapToFurniture: "Bútor illesztése bútorhoz",
    snapToWall: "Bútor illesztése falhoz",
    snapSelect1: "1. bútor kijelölése",
    snapSelect2: "2. cél kiválasztása",
    shortcuts: "Gyorsbillentyűk",
    shortcutMeasure: "Mérés mód",
    shortcutMoveRotate: "Mozgatás / Forgatás",
    shortcutSnap: "Tapadás be/ki",
    shortcutSelectSnap: "Kijelöléses snap",
    shortcutInfo: "Info panel",
    shortcutEscape: "Kilépés / reset",
    shortcutSizeLabels: "Méret címkék",
    drag: "húzás",
    measureMode: "Mérés mód",
    measureSelectPoint: "Pont kijelölés",
    measureFinish: "Befejezés",
    moveMode: "Mozgatás",
    vertical: "Függőleges",
    horizontal: "Vízszintes",
    rotateMode: "Forgatás",
    tilt: "Buktatás",
    roomSizeMm: "Szoba méretei (mm)",
    measureTotal: "Teljes távolság",
    measureX: "Szélességen (X) a távolság",
    measureY: "Magasságban (Y) a távolság",
    measureZ: "Mélységen (Z) a távolság",
    info: "Információk",
    moveAndRotate: "Mozgatás és forgatás",
    move: "Mozgatás",
    snapOff: "Tapadás ki.",
    snapOn: "Tapadás be.",
    apply: "Alkalmazás",
    saveConfigPrompt: "Adj nevet a beállításnak:",
    selectScript: "Terv kiválasztása",
    back: "Vissza",
    saveFurniture: "Bútor mentése",
    selectRoom: "Válassz szobát",
    selectRoomPlaceholder: "-- Válassz egy szobát --",
    originalSettings: "Eredeti beállítások",
    saveSettings: "Beállítás mentése",
    generalSettings: "Általános beállítások",
    settingsOf: "beállításai",
    addNewSize: "Új méret hozzáadás",
    employeeTitle: "Alkalmazottak",
    addEmployee: "Alkalmazott hozzáadása",
    usersTitle: "Felhasználók",
    addUser: "Felhasználó hozzáadása",
    worksTitle: "Munkák",
    workName: "Munka Neve",
    createNewScript: "Terv létrehozása",
    scriptImage: "Terv képe",
    scriptNamePlaceholder: "Terv név",
    room: "Szoba",
    imageAfterSaveHint: "Nincs feltöltött tervkép.",
    changeImage: "Kép hozzáadása vagy cseréje",
    saveScript: "Terv mentése",
    confirmCloseScript: "Biztosan bezárod a tervet?",
    referencedScriptSettings: "Hivatkozott terv beállításai",
    referenceScript: "Referencia terv",
    defaultValue: "Alapértelmezett érték",
    addSetting: "Beállítás hozzáadása",
    settingsListTitle: "Beállítások",
    settingsValue: "Beállítás értéke",
    noWorks: "Még nincs munka létrehozva",
    orderId: "Azonosító",
    paidAmmount: "Fizetett összeg",
    totalAmmount: "Teljes összeg",

    paidAmount: "Fizetett összeg",
    totalAmount: "Teljes összeg",
    labor: "Munkadíj",
    editClient: "Kliens szerkesztése",
    newWork: "Új munka",
    workCount: "Munkák száma",
    activeWorks: "Aktív munkák",
    completedWorks: "Befejezett munkák",
    remainingPayment: "Fennmaradó fizetés",
    previousWorks: "Előző munkák",
    clientWorks: " munkái",
    selectMilling: "Válassz marást",
    table: "Tábla",
    noTable: "Nincs tábla",
    usedSheets: "Felhasznált táblák",
    cutLength: "Vágási hossz",
    work: "Munka",
    milling: "Marás",
    ammount: "Mennyiség",
    settingsAdd: "Beállítás hozzáadása",
    deleteSelected: "Kijelöltek törlése",
    noItemsForFilter: "Nincsenek elemek ehhez a szűrőhöz",
    userWorksTitle: "Munkái",
    unsavedChangesTitle: "Mentetlen módosítások",
    line: "sor",
    errorNoClient: "Hiba, nincs kliens kiválasztva",
    Unauthorized: "Nincs jogosultság",
    Error: "Hiba",
    deleteItemConfirm: "Biztosan törölni akarod ezt az elemet?",
    deleteUser: "Felhasználó törlése",
    noOrdersFromUser: "Ennek a felhasználónak nincs rendelése.",
    deleteUserConfirm: "Biztosan törölni akarod ezt a felhasználót?",
    deleteSelectedConfirm: "Biztosan törölni akarod a kijelölt elemeket?",
    sizeListBtn: "Méretlista",
    trim: "Szélezés",
    direction: "Irány",
    both: "Mindkettő",
    fullTable: "Egész tábla",
    halfTable: "Fél tábla",
    allowHalfTable: "Fél tábla engedélyezése",
    disallowHalfTable: "Fél tábla tiltása",
    selectTableFirst: "Az elhelyezéshez válassz ki egy táblát",
    placeItem: "Elem elhelyezése",
    cancelPlacement: "Elhelyezési kijelölés megszüntetése",
    placeInWaste: "Elem elhelyezése waste területre",
    lengthwise: "Hosszában",
    crosswise: "Keresztben",
    enableRotation: "Elem forgathatóvá tétele",
    enableRotationConfirm:
      "Ez az elem jelenleg nem forgatható. Biztosan szeretnéd forgathatóvá tenni és függőlegesen elhelyezni?",
    confirmRotation: "Igen, forgatható legyen",
    selectedItemMissing: "A kiválasztott elem már nem található.",
    invalidItemQuantity:
      "Az elem mennyiségének nullánál nagyobbnak kell lennie.",
    itemAlreadyFullyPlaced:
      "Az elem minden példánya már el van helyezve egy táblán.",
    invalidItemSize: "Az elem mérete érvénytelen, ezért nem helyezhető el.",
    tableColorMissing: "A kiválasztott táblához nincs szín rendelve.",
    itemColorMismatch:
      "Az elem színe nem egyezik a kiválasztott tábla színével.",
    rotationConfirmationRequired:
      "Ez az elem nem forgatható. Válaszd újra a függőleges elhelyezést, majd erősítsd meg a forgatás engedélyezését.",
    itemDoesNotFitVertical:
      "A kiválasztott elem függőleges helyzetben nem fér el ezen a maradékterületen.",
    itemDoesNotFitHorizontal:
      "A kiválasztott elem vízszintes helyzetben nem fér el ezen a maradékterületen.",
    datiOrderFailed: "Nem sikerült meghatározni az új elem adatsorrendjét.",
    datiWriteFailed: "Nem sikerült az elemet hozzáadni a tábla adataihoz.",
    itemPlacedVerticalRemaining:
      "Az elem függőlegesen elhelyezve. Még {{count}} darab helyezhető el.",
    itemPlacedHorizontalRemaining:
      "Az elem vízszintesen elhelyezve. Még {{count}} darab helyezhető el.",
    allItemsPlacedVertical: "Az elem minden példánya függőlegesen elhelyezve.",
    allItemsPlacedHorizontal:
      "Az elem minden példánya vízszintesen elhelyezve.",
    itemPlacedReplayFailedRemaining:
      "Az elem elhelyezve, de a tábla frissítése nem sikerült. Még {{count}} darab helyezhető el.",
    itemPlacedReplayFailed:
      "Az elem elhelyezve, de az érintett tábla frissítése nem sikerült.",
    stableDatiLinkMissing:
      "A pozícióhoz nem tartozik megbízható adatkapcsolat, ezért a törlés biztonsági okból megszakadt.",
    riferimentiRenumberFailed:
      "A hivatkozások nem számozhatók újra biztonságosan.",
    righeRenumberFailed: "A vágási sorok nem számozhatók újra biztonságosan.",
    righeAbsRenumberFailed:
      "Az abszolút vágási sorok nem számozhatók újra biztonságosan.",
    invalidNewTableSize: "Az új tábla mérete érvénytelen.",
    currentTableColorMissing: "Az aktuális tábla színe nem található.",
    invalidTrim: "A szélezés értéke érvénytelen.",
    halfTableAdded: "A fél tábla hozzáadva.",
    fullTableAdded: "A teljes tábla hozzáadva.",
    newTableSizeMissing: "Az új tábla mérete nincs megadva.",
    invalidFullTableSize: "A színhez tartozó teljes táblaméret érvénytelen.",
    tableMarkedForDeletion:
      "A tábla törlésre jelölve. Az elemek lekerültek róla, de megmaradtak.",
    deletePosition: "Pozíció törlése",
    previousColor: "Előző szín",
    nextColor: "Következő szín",
    previousTable: "Előző tábla",
    nextTable: "Következő tábla",
    newTableSettings: "Új tábla beállításai",
    trimHelp:
      "Ez határozza meg az üres tábla használható területének kezdőpontját és méretét.",
    cutOrientation: "Vágási irány",
    placementSelectionCancelled: "Az elhelyezési kijelölés megszüntetve.",
    placementHintVertical:
      "Kattints egy megfelelő maradékterületre a függőleges elhelyezéshez.",
    placementHintHorizontal:
      "Kattints egy megfelelő maradékterületre a vízszintes elhelyezéshez.",
    sizeListGenerated: "A méretlista sikeresen elkészült.",
    sizeListUnsavedChanges:
      "A méretlista nem készíthető el, mert vannak mentetlen módosítások.",
    sizeListNoTables:
      "A méretlista nem készíthető el, mert nincs létrehozott tábla.",
    sizeListSaveRequired:
      "A méretlista elkészítése előtt minden módosítást el kell menteni.",
    sizeListItemsUnplaced:
      "A méretlista nem készíthető el, mert nincs minden elem táblára helyezve.",
    noChangesToSave: "Nincs mentendő változás.",
    showMilling: "Marás megjelenítése"
  },
  ro: {
    workQuantityShort: "Buc.",
    workMaterialsEmpty: "Nu există materiale.",
    workFilesEmpty: "Nu există fișiere.",
    scriptsHeaderShort_id: "ID",
    scriptsHeaderShort_name: "Nume",
    scriptsHeaderShort_room: "Cam.",
    scriptsDuplicate: "Duplicare",
    modify: "Modificare",
    clientsHeaderShort_id: "ID",
    clientsHeaderShort_name: "Nume",
    clientsHeaderShort_clientSold: "Sold",
    clientsHeaderShort_address: "Adr.",
    employeesTableEmpty: "Nu există angajați.",
    employeesHeaderShort_id: "ID",
    employeesHeaderShort_name: "Nume",
    employeesHeaderShort_email: "E-mail",
    employeesHeaderShort_username: "Utiliz.",
    employeesHeaderShort_role: "Rol",
    employeesHeaderShort_address: "Adr.",
    usersTableEmpty: "Nu există utilizatori.",
    usersHeaderShort_id: "ID",
    usersHeaderShort_name: "Nume",
    usersHeaderShort_email: "E-mail",
    usersHeaderShort_username: "Utiliz.",
    usersHeaderShort_balance: "Sold",
    usersHeaderShort_phone: "Tel.",
    usersHeaderShort_address: "Adr.",
    worksHeaderShort_id: "ID",
    worksHeaderShort_client: "Cl.",
    worksHeaderShort_user: "Tâmpl.",
    worksHeaderShort_workName: "Lucrare",
    worksHeaderShort_paid: "Plăt.",
    worksHeaderShort_totalPrice: "Preț",
    worksHeaderShort_laborCost: "Man.",
    worksHeaderShort_status: "St.",
    worksHeaderShort_measured: "Măs.",
    worksHeaderShort_ordered: "Com.",
    worksHeaderShort_completed: "Fin.",
    overview: "Informații",
    help: "Cum să faci?",
    id: "ID",
    name: "Nume",
    exampleShort: "Ex.",
    width: "Lățime",
    height: "Înălțime",
    depth: "Adâncime",
    add: "Adăugare",
    delete: "Ștergere",
    available: "Disponibil",
    notAvailable: "Indisponibil",
    rotatable: "Rotabil",
    notRotatable: "Nerotabil",
    rotable: "Rotabil",
    notRotable: "Nerotabil",
    splittable: "Divizabil",
    notSplittable: "Nedivizabil",
    none: "—",
    month: "Lună",
    week: "Săptămână",
    day: "Zi",
    client: "Client",
    user: "Tâmplar",
    paid: "Plătit",
    totalPrice: "Preț total",
    laborCost: "Manoperă",
    status: "Stare",
    measured: "Măsurat",
    ordered: "Comandat",
    completed: "Finalizat",
    Measured: "Măsurat",
    Ordered: "Comandat",
    Completed: "Finalizat",
    weekdays: [
      "Luni",
      "Marți",
      "Miercuri",
      "Joi",
      "Vineri",
      "Sâmbătă",
      "Duminică"
    ],
    kant: "Cant",
    colors: "Culori",
    color: "Culoare",
    addColor: "Adaugă culoare",
    image: "Imagine",
    dimension: "Dimensiune",
    material: "Material",
    group: "Grup",
    price: "Preț",
    splitDimension: "Dimensiune divizată",
    welcome: "Bun venit",
    logoutTitle: "Sigur vrei să ieși?",
    logoutBody: "Modificările nesalvate se vor pierde.",
    cancel: "Anulează",
    logout: "Deconectare",
    search: "Căutare",
    noSearchResults: "Nu s-au găsit rezultate.",
    clientSold: "De plătit",
    dashboard: "Panou",
    clients: "Clienți",
    employee: "Angajați",
    users: "Utilizatori",
    noUsers: "Nu există utilizatori de afișat.",
    assignedWorkCount: "Număr de lucrări",
    orderedWorkCount: "Lucrări comandate",
    createWork: "Creare lucrare",
    createClient: "Creare client",
    createCarpenter: "Creare tâmplar",
    selectClient: "Selectează un client",
    selectCarpenter: "Selectează un tâmplar",
    works: "Lucrări",
    scripts: "Planuri",
    schedule: "Calendar",
    reports: "Rapoarte",
    settings: "Setări",
    save: "Salvare",
    createdItemsUndo: "Înapoi",
    createdItemsSaving: "Se salvează…",
    createdItemsRedo: "Înainte",
    cancelBtn: "Anulează",
    saveBtn: "Salvează",
    actions: "Acțiuni",
    visible: "Vizibil",
    show: "Afișează",
    hide: "Ascunde",
    username: "Nume utilizator",
    email: "Email",
    address: "Adresă",
    role: "Rol",
    companyUser: "Utilizator companie",
    companyAdmin: "Administrator companie",
    admin: "Administrator",
    userRole: "Utilizator",
    balance: "Sold",
    phone: "Telefon",
    filter: "Filtrare",
    filterValue: "Valoare filtru",
    sort: "Sortare",
    selectValue: "Alege valoare",
    filterMin: "Min",
    filterMax: "Max",
    pending: "În așteptare",
    Pending: "În așteptare",
    active: "Activ",
    cancelled: "Anulat",
    quantity: "Cantitate",
    addConditional: "Adaugă condiție",
    quantityExpressionPlaceholder: "Cantitate sau formulă",
    condition: "Condiție",
    leftValue: "Partea stângă",
    rightValue: "Partea dreaptă",
    relation: "Relație",
    whenConditionTrue: "Dacă este adevărat",
    whenConditionFalse: "Dacă este fals",
    insertableElements: "Elemente inserabile",
    generalData: "Date generale",
    editName: "Editează numele",
    editMaterial: "Editează materialul",
    removeConditional: "Șterge condiția",
    keepTrueBranch: "Șterge condiția și păstrează ramura adevărată",
    keepFalseBranch: "Șterge condiția și păstrează ramura falsă",
    clearExpression: "Șterge expresia",
    deleteToken: "Șterge elementul inserat",
    rotationQuarterTurns: "Rotație: 0 = 0°, 1 = 90°, 2 = 180°, 3 = 270°.",
    dimensions: "Dimensiuni",
    position: "Poziție",
    rotation: "Rotație",
    noItems: "Nu există piese",
    details: "Detalii",
    length: "Lungime",
    quantityShort: "Buc",
    allColors: "Toate culorile",
    noColors: "Fără culori",
    millings: "Frezări",
    preview: "Previzualizare",
    download: "Descărcare",
    uploadFiles: "Import fișier",
    uploading: "Se încarcă...",
    filesUploaded: "Fișier(e) încărcate cu succes.",
    uploadError: "Eroare la încărcare.",
    downloadError: "Eroare la descărcare.",
    deleteError: "Eroare la ștergere.",
    confirmDelete: "Sigur dorești să ștergi fișierul?",
    fileDeleted: "Fișier șters.",
    searchPlaceholder: "Căutare... (* = orice)",
    noColor: "- Fără culoare",
    unknownColor: "Culoare necunoscută",
    noMilling: "- Fără frezare",
    noMilling1: "Fără frezare",
    noMillingAvailable: "Nu există frezare disponibilă",
    manualImport: "Import manual",
    importInProgress: "Import în curs...",
    cmrStats: "Statistici",
    cmrTotalParts: "Total piese",
    cmrUsedParts: "Piese folosite",
    cmrUsedSheets: "Plăci folosite",
    cmrYield: "Randament",
    cmrLastYield: "Ultimul randament",
    cmrCutLength: "Lungime tăiere",
    cmrBandingLength: "Lungime cant",
    cmrBandingByType: "Cant pe tip",
    cmrType: "Tip",
    cmrLengthMm: "Lungime (mm)",
    cmrSheets: "Plăci",
    cmrParts: "Piese",
    cmrComment: "Comentariu",
    yes: "Da",
    no: "Nu",
    model: "Model",
    allWorksTitle: "Lucrări",
    addClient: "Adaugă client",
    toolbarMeasure: "Măsurare distanță",
    toolbarSnapping: "Magnetism",
    toolbarMove: "Mutare (stânga: XZ, dreapta: sus/jos)",
    toolbarRotate: "Rotire (stânga: orizontal)",
    toolbarSizeLabelsOn: "Etichetă dimensiune (activat)",
    toolbarSizeLabelsOff: "Etichetă dimensiune (dezactivat)",
    toolbarGroupingOn: "Mutare grup (activat) [G]",
    toolbarGroupingOff: "Mutare grup (dezactivat) [G]",
    createdItemsTitle: "Piese generate",
    clientsTitle: "Clienți",
    filterByName: "După nume",
    filterByBalance: "După sold",
    filterByAddress: "După adresă",
    sortNameAsc: "Nume (A-Z)",
    sortNameDesc: "Nume (Z-A)",
    sortBalanceAsc: "Sold (crescător)",
    sortBalanceDesc: "Sold (descrescător)",
    noClients: "Nu există clienți",
    rotatableShort: "Rot.",
    longEdge: "Cant lung",
    shortEdge: "Cant scurt",
    addNewItem: "+ Adaugă element nou",
    scriptItems: "Elementele planului",
    selectedCount: "{{count}} selectat(e)",
    edgeType: "Cant",
    longEdgeCount: "Lung c.",
    shortEdgeCount: "Lat c.",
    saveSuccess: "Salvarea s-a efectuat cu succes.",
    saveFailed: "A apărut o eroare la salvare.",
    savingInProgress: "Salvare în curs…",
    addNewObject: "Adaugă obiect nou",
    objects: "Obiecte",
    object: "Obiect",
    settingsTitle: "Setări",
    millingMaterialChangeTitle: "Schimbare material",
    millingMaterialChangeConfirm: "Sigur dorești să schimbi materialul?",
    millingMaterialChangeAccept: "Da, schimbă",
    allGroups: "Toate grupurile",
    chooseColor: "Selectare culoare",
    replaceColor: "Înlocuire culoare",
    forgotPasswordTitle: "Parolă uitată",
    forgotPasswordSuccess:
      "Dacă există un cont cu acel email, a fost trimis un link de resetare.",
    forgotPasswordError:
      "Ceva a mers greșit. Vă rugăm să încercați din nou mai târziu.",
    forgotPasswordSubmit: "Trimite link de resetare",
    loading: "Se încarcă...",
    loginTitle: "Autentificare",
    loginError: "Nume de utilizator sau parolă greșită.",
    loginOfflineError:
      "Nu există conexiune la rețea, verificați conexiunea la internet.",
    loginOfflineWarning: "Ești offline, verificați conexiunea la internet.",
    usernamePlaceholder: "Introduceți numele de utilizator",
    password: "Parolă",
    passwordPlaceholder: "Introduceți parola",
    rememberMe: "Ține-mă minte",
    register: "Înregistrare",
    forgotPassword: "Ai uitat parola?",
    repeatPassword: "Repetă parola",
    registerPasswordMismatch: "Parolele nu coincid.",
    registerSuccess: "Înregistrare reușită! Te poți autentifica acum.",
    registerError: "Înregistrare eșuată. Vă rugăm verificați datele.",
    backToLogin: "Înapoi la autentificare",
    resetPasswordTitle: "Resetare parolă",
    resetPasswordWelcome1Error:
      'Utilizarea parolei "Welcome1" nu este permisă, vă rugăm alegeți alta.',
    resetPasswordMismatch:
      "Cele două parole nu coincid, vă rugăm verificați din nou.",
    resetPasswordSameAsPrevious:
      "Parola nouă nu poate fi aceeași cu parola anterioară.",
    resetPasswordSuccess:
      "Parola a fost schimbată cu succes. Redirecționare către pagina de autentificare…",
    resetPasswordError:
      "A apărut o eroare, vă rugăm încercați din nou mai târziu.",
    resetPasswordSubmit: "Salvează parola",
    newPassword: "Parolă nouă",
    newPasswordPlaceholder: "Introduceți parola nouă",
    repeatPasswordPlaceholder: "Reintroduceți parola nouă",
    saving: "Se salvează…",
    millingsListTitle: "Lista frezărilor",
    millingNameRequired: "Numele este obligatoriu.",
    millingNamePlaceholder: "Ex. frezare nutului",
    millingSaveError: "Eroare la salvare.",
    noData: "Nu există date",
    tableLabel: "Placă",
    filterAll: "Listă completă",
    colorSwapFailed: "Înlocuirea culorii a eșuat. Vă rugăm încercați din nou.",
    addItemFailed:
      "Nu s-a putut adăuga elementul nou, vă rugăm încercați din nou.",
    generatingInProgress: "Generare în curs...",
    generateAlreadyOptimal: "Rezultatul este deja optim.",
    generateSuccess: "Generare reușită.",
    saveChangesTitle: "Salvare modificări",
    saveChangesBeforeGenerate:
      "Există modificări nesalvate. Să le salvez înainte de generare?",
    saveAndGenerate: "Salvează & Generează",
    noTablesYet: "Nu există plăci, generați mai întâi",
    addTableFailed: "Nu s-a putut adăuga o placă nouă.",
    deleteTableConfirm:
      "Sigur doriți să ștergeți această placă și elementele asociate?",
    saveChangesConfirm: "Sigur doriți să salvați modificările?",
    rotateFailed: "Rotația nu este posibilă, nu există spațiu liber.",
    unsavedChangesBody:
      "Există modificări nesalvate. Să le salvăm înainte de a continua?",
    saveAndContinue: "Salvare & Continuare",
    discardChanges: "Renunțare & Continuare",
    editBtn: "Editare",
    exportBtn: "Exportare",
    generateBtn: "Generare",
    addTable: "Adăugare placă",
    deleteTable: "Ștergere placă",
    moveToTable: "Mutare la:",
    rotateTable: "Rotire placă",
    bgOff: "Fundal dezactivat",
    bgOn: "Fundal activat",
    detailsOff: "Detalii dezactivate",
    detailsOn: "Detalii activate",
    linesOff: "Linii dezactivate",
    linesOn: "Linii activate",
    tableId: "Identificator placă",
    unknownId: "Identificator necunoscut",
    noTableSelected: "Nicio placă selectată",
    currentTable: "Placă curentă",
    avgUsage: "Utilizare medie",
    partCount: "Număr piese",
    measureCount: "Număr dimensiuni",
    kantTotal: "Total cant",
    usage: "Utilizare",
    noSize: "Fără dimensiune",
    posX: "Dreapta-Stânga",
    posY: "Sus-Jos",
    posZ: "Față-Spate",
    rotX: "Față-Spate",
    rotY: "Orizontal",
    rotZ: "Lateral",
    snapInfo: "Aliniere mobilă",
    snapToFurniture: "Aliniere mobilă la mobilă",
    snapToWall: "Aliniere mobilă la perete",
    snapSelect1: "1. selectare mobilă",
    snapSelect2: "2. selectare țintă",
    shortcuts: "Comenzi rapide",
    shortcutMeasure: "Mod măsurare",
    shortcutMoveRotate: "Mutare / Rotire",
    shortcutSnap: "Magnetism on/off",
    shortcutSelectSnap: "Snap selectiv",
    shortcutInfo: "Panou info",
    shortcutEscape: "Ieșire / reset",
    shortcutSizeLabels: "Etichete dimensiuni",
    drag: "tragere",
    measureMode: "Mod măsurare",
    measureSelectPoint: "Selectare punct",
    measureFinish: "Finalizare",
    moveMode: "Mutare",
    vertical: "Vertical",
    horizontal: "Orizontal",
    rotateMode: "Rotire",
    tilt: "Înclinare",
    roomSizeMm: "Dimensiuni cameră (mm)",
    measureTotal: "Distanță totală",
    measureX: "Distanță pe lățime (X)",
    measureY: "Distanță pe înălțime (Y)",
    measureZ: "Distanță pe adâncime (Z)",
    info: "Informații",
    moveAndRotate: "Mutare și rotire",
    move: "Mutare",
    snapOff: "Magnetism off.",
    snapOn: "Magnetism on.",
    apply: "Aplicare",
    saveConfigPrompt: "Dați un nume setărilor:",
    selectScript: "Selectare plan",
    back: "Înapoi",
    saveFurniture: "Salvare mobilă",
    selectRoom: "Selectați camera",
    selectRoomPlaceholder: "-- Selectați o cameră --",
    originalSettings: "Setări originale",
    saveSettings: "Salvare setări",
    generalSettings: "Setări generale",
    settingsOf: "setări",
    addNewSize: "Adăugare dimensiune nouă",
    employeeTitle: "Angajații",
    addEmployee: "Adăugare angajat",

    usersTitle: "Utilizatori",
    addUser: "Adăugare utilizator",
    worksTitle: "Lucrări",
    workName: "Nume de lucrare",
    createNewScript: "Plan nou",
    scriptImage: "Imagine plan",
    scriptNamePlaceholder: "Nume de plan",
    room: "Cameră",
    imageAfterSaveHint: "Nu există o imagine încărcată pentru plan.",
    changeImage: "Adaugă sau schimbă imaginea",
    saveScript: "Salvează planul",
    confirmCloseScript: "Sigur vrei să închizi planul?",
    referencedScriptSettings: "Setările planului referențiat",
    referenceScript: "Plan referat",
    defaultValue: "Valoare def",
    addSetting: "Adăugare setare",
    settingsListTitle: "Setări",
    settingsValue: "Valoare setare",
    noWorks: "Nu ai lucrare creată",
    orderId: "Id",
    paidAmmount: "Suma plătită",
    totalAmmount: "Suma totală",
    paidAmount: "Suma plătită",
    totalAmount: "Suma totală",
    labor: "Manoperă",
    editClient: "Editează client",
    newWork: "Lucrare nouă",
    workCount: "Număr lucrări",
    activeWorks: "Lucrări active",
    completedWorks: "Lucrări finalizate",
    remainingPayment: "Plată rămasă",
    previousWorks: "Lucrări anterioare",
    clientWorks: " lucrări",
    selectMilling: "Selectați frezare",
    table: "Tablă",
    noTable: "Niciuna tablă",
    usedSheets: "Plăci folosite",
    cutLength: "Lungime tăiere",
    work: "Lucrare",
    milling: "Frezare",
    ammount: "Cantitate",
    settingsAdd: "Adăugare setare",
    deleteSelected: "Șterge selecția",
    noItemsForFilter: "Nu există elemente pentru acest filtru",
    userWorksTitle: "Lucrări",
    unsavedChangesTitle: "Modificări nesalvate",
    line: "rând",
    errorNoClient: "Eroare, niciun client selectat",
    Unauthorized: "Neautorizat",
    Error: "Eroare",
    deleteItemConfirm: "Sigur doriți să ștergeți acest element?",
    deleteUser: "Ștergere utilizator",
    noOrdersFromUser: "Acest utilizator nu are comenzi.",
    deleteUserConfirm: "Sigur doriți să ștergeți acest utilizator?",
    deleteSelectedConfirm: "Sigur doriți să ștergeți elementele selectate?",
    sizeListBtn: "Listă dimensiuni",
    trim: "Margine",
    direction: "Direcție",
    both: "Ambele",
    fullTable: "Tablă întreagă",
    halfTable: "Jumătate tablă",
    allowHalfTable: "Permite jumătate tablă",
    disallowHalfTable: "Nu permite jumătate tablă",
    selectTableFirst: "Pentru plasare, selectează mai întâi o placă",
    placeItem: "Plasare element",
    cancelPlacement: "Anulează selectarea pentru plasare",
    placeInWaste: "Plasează elementul în zona de rest",
    lengthwise: "Pe lungime",
    crosswise: "Transversal",
    enableRotation: "Permite rotirea elementului",
    enableRotationConfirm:
      "Acest element nu poate fi rotit momentan. Sigur dorești să permiți rotirea și să îl plasezi vertical?",
    confirmRotation: "Da, permite rotirea",
    selectedItemMissing: "Elementul selectat nu mai poate fi găsit.",
    invalidItemQuantity:
      "Cantitatea elementului trebuie să fie mai mare decât zero.",
    itemAlreadyFullyPlaced:
      "Toate exemplarele elementului sunt deja plasate pe o placă.",
    invalidItemSize:
      "Dimensiunea elementului este invalidă, de aceea nu poate fi plasat.",
    tableColorMissing: "Placa selectată nu are o culoare atribuită.",
    itemColorMismatch:
      "Culoarea elementului nu corespunde culorii plăcii selectate.",
    rotationConfirmationRequired:
      "Acest element nu poate fi rotit. Selectează din nou plasarea verticală și confirmă activarea rotirii.",
    itemDoesNotFitVertical:
      "Elementul selectat nu încape în poziție verticală în această zonă rămasă.",
    itemDoesNotFitHorizontal:
      "Elementul selectat nu încape în poziție orizontală în această zonă rămasă.",
    datiOrderFailed:
      "Nu s-a putut determina ordinea de date pentru noul element.",
    datiWriteFailed: "Elementul nu a putut fi adăugat la datele plăcii.",
    itemPlacedVerticalRemaining:
      "Elementul a fost plasat vertical. Mai pot fi plasate încă {{count}} bucăți.",
    itemPlacedHorizontalRemaining:
      "Elementul a fost plasat orizontal. Mai pot fi plasate încă {{count}} bucăți.",
    allItemsPlacedVertical:
      "Toate exemplarele elementului au fost plasate vertical.",
    allItemsPlacedHorizontal:
      "Toate exemplarele elementului au fost plasate orizontal.",
    itemPlacedReplayFailedRemaining:
      "Elementul a fost plasat, dar actualizarea plăcii a eșuat. Mai pot fi plasate încă {{count}} bucăți.",
    itemPlacedReplayFailed:
      "Elementul a fost plasat, dar actualizarea plăcii afectate a eșuat.",
    stableDatiLinkMissing:
      "Poziția nu are o legătură de date sigură, astfel ștergerea a fost oprită din motive de siguranță.",
    riferimentiRenumberFailed:
      "Referințele nu pot fi renumerotate în siguranță.",
    righeRenumberFailed:
      "Liniile de tăiere nu pot fi renumerotate în siguranță.",
    righeAbsRenumberFailed:
      "Liniile absolute de tăiere nu pot fi renumerotate în siguranță.",
    invalidNewTableSize: "Dimensiunea noii plăci este invalidă.",
    currentTableColorMissing: "Culoarea plăcii curente nu a fost găsită.",
    invalidTrim: "Valoarea marginii este invalidă.",
    halfTableAdded: "Jumătatea de placă a fost adăugată.",
    fullTableAdded: "Placa întreagă a fost adăugată.",
    newTableSizeMissing: "Dimensiunea noii plăci nu este specificată.",
    invalidFullTableSize:
      "Dimensiunea plăcii întregi asociată culorii este invalidă.",
    tableMarkedForDeletion:
      "Placa a fost marcată pentru ștergere. Elementele au fost eliminate de pe ea, dar au fost păstrate.",
    deletePosition: "Ștergere poziție",
    previousColor: "Culoarea anterioară",
    nextColor: "Culoarea următoare",
    previousTable: "Placa anterioară",
    nextTable: "Placa următoare",
    newTableSettings: "Setările noii plăci",
    trimHelp:
      "Această valoare stabilește punctul de început și dimensiunea zonei utilizabile a unei plăci goale.",
    cutOrientation: "Direcția de tăiere",
    placementSelectionCancelled: "Selectarea pentru plasare a fost anulată.",
    placementHintVertical:
      "Fă clic pe o zonă rămasă potrivită pentru plasarea verticală.",
    placementHintHorizontal:
      "Fă clic pe o zonă rămasă potrivită pentru plasarea orizontală.",
    sizeListGenerated: "Lista de dimensiuni a fost generată cu succes.",
    sizeListUnsavedChanges:
      "Lista de dimensiuni nu poate fi generată deoarece există modificări nesalvate.",
    sizeListNoTables:
      "Lista de dimensiuni nu poate fi generată deoarece nu există nicio placă creată.",
    sizeListSaveRequired:
      "Toate modificările trebuie salvate înainte de generarea listei de dimensiuni.",
    sizeListItemsUnplaced:
      "Lista de dimensiuni nu poate fi generată deoarece nu toate elementele sunt plasate pe plăci.",
    noChangesToSave: "Nu există modificări de salvat.",
    showMilling: "Afișează frezarea "
  },
  en: {
    workQuantityShort: "Qty.",
    workMaterialsEmpty: "No materials.",
    workFilesEmpty: "No files.",
    scriptsHeaderShort_id: "ID",
    scriptsHeaderShort_name: "Name",
    scriptsHeaderShort_room: "Rm.",
    scriptsDuplicate: "Duplicate",
    modify: "Modify",
    clientsHeaderShort_id: "ID",
    clientsHeaderShort_name: "Name",
    clientsHeaderShort_clientSold: "Bal.",
    clientsHeaderShort_address: "Addr.",
    employeesTableEmpty: "No employees.",
    employeesHeaderShort_id: "ID",
    employeesHeaderShort_name: "Name",
    employeesHeaderShort_email: "Email",
    employeesHeaderShort_username: "User",
    employeesHeaderShort_role: "Role",
    employeesHeaderShort_address: "Addr.",
    usersTableEmpty: "No users.",
    usersHeaderShort_id: "ID",
    usersHeaderShort_name: "Name",
    usersHeaderShort_email: "Email",
    usersHeaderShort_username: "User",
    usersHeaderShort_balance: "Bal.",
    usersHeaderShort_phone: "Tel.",
    usersHeaderShort_address: "Addr.",
    worksHeaderShort_id: "ID",
    worksHeaderShort_client: "Cl.",
    worksHeaderShort_user: "User",
    worksHeaderShort_workName: "Work",
    worksHeaderShort_paid: "Pd.",
    worksHeaderShort_totalPrice: "Total",
    worksHeaderShort_laborCost: "Labor",
    worksHeaderShort_status: "St.",
    worksHeaderShort_measured: "Meas.",
    worksHeaderShort_ordered: "Ord.",
    worksHeaderShort_completed: "Done",
    overview: "Overview",
    help: "How to do?",
    id: "ID",
    name: "Name",
    exampleShort: "e.g.",
    width: "Width",
    height: "Height",
    depth: "Depth",
    add: "Add",
    delete: "Delete",
    available: "Available",
    notAvailable: "Unavailable",
    rotatable: "Rotatable",
    notRotatable: "Not rotatable",
    rotable: "Rotatable",
    notRotable: "Not rotatable",
    splittable: "Splittable",
    notSplittable: "Not splittable",
    none: "—",
    month: "Month",
    week: "Week",
    day: "Day",
    client: "Client",
    user: "Carpenter",
    paid: "Paid",
    totalPrice: "Total price",
    laborCost: "Labor cost",
    status: "Status",
    measured: "Measured",
    ordered: "Ordered",
    completed: "Completed",
    Measured: "Measured",
    Ordered: "Ordered",
    Completed: "Completed",
    weekdays: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ],
    kant: "Edge",
    colors: "Colors",
    color: "Color",
    addColor: "Add Color",
    image: "Image",
    dimension: "Dimension",
    material: "Material",
    group: "Group",
    price: "Price",
    splitDimension: "Split size",
    welcome: "Welcome",
    logoutTitle: "Are you sure you want to log out?",
    logoutBody: "Unsaved changes will be lost.",
    cancel: "Cancel",
    logout: "Log out",
    search: "Search",
    noSearchResults: "No results found.",
    clientSold: "Sold",
    dashboard: "Dashboard",
    clients: "Clients",
    employee: "Employees",
    users: "Users",
    noUsers: "No users to display yet.",
    assignedWorkCount: "Work count",
    orderedWorkCount: "Ordered work count",
    createWork: "Create work",
    createClient: "Create client",
    createCarpenter: "Create carpenter",
    selectClient: "Select a client",
    selectCarpenter: "Select a carpenter",
    works: "Works",
    scripts: "Scripts",
    schedule: "Calendar",
    reports: "Reports",
    settings: "Settings",
    save: "Save",
    createdItemsUndo: "Undo",
    createdItemsSaving: "Saving…",
    createdItemsRedo: "Redo",
    cancelBtn: "Cancel",
    saveBtn: "Save",
    actions: "Actions",
    visible: "Visible",
    show: "Show",
    hide: "Hide",
    username: "Username",
    email: "Email",
    address: "Address",
    role: "Role",
    companyUser: "Company user",
    companyAdmin: "Company admin",
    admin: "Admin",
    userRole: "User",
    balance: "Balance",
    phone: "Phone",
    filter: "Filter",
    filterValue: "Filter value",
    sort: "Sort",
    selectValue: "Select value",
    filterMin: "Min",
    filterMax: "Max",
    pending: "Pending",
    Pending: "Pending",
    active: "Active",
    cancelled: "Cancelled",
    quantity: "Quantity",
    addConditional: "Add condition",
    quantityExpressionPlaceholder: "Quantity or formula",
    condition: "Condition",
    leftValue: "Left side",
    rightValue: "Right side",
    relation: "Relation",
    whenConditionTrue: "When true",
    whenConditionFalse: "When false",
    insertableElements: "Insertable elements",
    generalData: "General data",
    editName: "Edit name",
    editMaterial: "Edit material",
    removeConditional: "Remove conditional",
    keepTrueBranch: "Remove conditional, keep true branch",
    keepFalseBranch: "Remove conditional, keep false branch",
    clearExpression: "Clear expression",
    deleteToken: "Delete inserted element",
    rotationQuarterTurns: "Rotation: 0 = 0°, 1 = 90°, 2 = 180°, 3 = 270°.",
    dimensions: "Dimensions",
    position: "Position",
    rotation: "Rotation",
    noItems: "No items",
    details: "Details",
    length: "Length",
    quantityShort: "Qty",
    allColors: "All colors",
    noColors: "No colors",
    millings: "Millings",
    preview: "Preview",
    download: "Download",
    uploadFiles: "File import",
    uploading: "Uploading...",
    filesUploaded: "File(s) uploaded successfully.",
    uploadError: "Upload error occurred.",
    downloadError: "Download error.",
    deleteError: "Delete error.",
    confirmDelete: "Are you sure you want to delete this file?",
    fileDeleted: "File deleted.",
    searchPlaceholder: "Search... (* = any)",
    noColor: "- No color",
    unknownColor: "Unknown color",
    noMilling: "- No milling",
    noMilling1: "No milling",
    noMillingAvailable: "No milling available",
    manualImport: "Manual import",
    importInProgress: "Import in progress...",
    cmrStats: "Statistics",
    cmrTotalParts: "Total parts",
    cmrUsedParts: "Used parts",
    cmrUsedSheets: "Used sheets",
    cmrYield: "Yield",
    cmrLastYield: "Last yield",
    cmrCutLength: "Cut length",
    cmrBandingLength: "Banding length",
    cmrBandingByType: "Banding by type",
    cmrType: "Type",
    cmrLengthMm: "Length (mm)",
    cmrSheets: "Sheets",
    cmrParts: "Parts",
    cmrComment: "Comment",
    yes: "Yes",
    no: "No",
    model: "Model",
    allWorksTitle: "Works",
    addClient: "Add client",
    toolbarMeasure: "Distance measure",
    toolbarSnapping: "Snapping",
    toolbarMove: "Move (left: XZ, right: up/down)",
    toolbarRotate: "Rotate (left: horizontal)",
    toolbarSizeLabelsOn: "Size labels (on)",
    toolbarSizeLabelsOff: "Size labels (off)",
    toolbarGroupingOn: "Group move (on) [G]",
    toolbarGroupingOff: "Group move (off) [G]",
    createdItemsTitle: "Created items",
    clientsTitle: "Clients",
    filterByName: "By name",
    filterByBalance: "By balance",
    filterByAddress: "By address",
    sortNameAsc: "Name (A-Z)",
    sortNameDesc: "Name (Z-A)",
    sortBalanceAsc: "Balance (ascending)",
    sortBalanceDesc: "Balance (descending)",
    noClients: "No clients found",
    rotatableShort: "Rot.",
    longEdge: "Long edge",
    shortEdge: "Short edge",
    addNewItem: "+ Add new item",
    scriptItems: "Script items",
    selectedCount: "{{count}} selected",
    edgeType: "Edge",
    longEdgeCount: "Long e.",
    shortEdgeCount: "Width e.",
    saveSuccess: "Saved successfully.",
    saveFailed: "An error occurred while saving.",
    savingInProgress: "Saving in progress…",
    addNewObject: "Add new object",
    objects: "Objects",
    object: "Object",
    settingsTitle: "Settings",
    millingMaterialChangeTitle: "Change material",
    millingMaterialChangeConfirm: "Are you sure you want to switch material?",
    millingMaterialChangeAccept: "Yes, switch",
    allGroups: "All groups",
    chooseColor: "Choose color",
    replaceColor: "Replace color",
    forgotPasswordTitle: "Forgot Password",
    forgotPasswordSuccess:
      "If an account with that email exists, a reset link was sent.",
    forgotPasswordError: "Something went wrong. Please try again later.",
    forgotPasswordSubmit: "Send Reset Link",
    loading: "Loading...",
    loginTitle: "Login",
    loginError: "Wrong username or password.",
    loginOfflineError:
      "No network connection, please check your internet connection.",
    loginOfflineWarning:
      "You are offline, please check your internet connection.",
    usernamePlaceholder: "Enter your username",
    password: "Password",
    passwordPlaceholder: "Enter your password",
    rememberMe: "Remember me",
    register: "Register",
    forgotPassword: "Forgot your password?",
    repeatPassword: "Repeat Password",
    registerPasswordMismatch: "Passwords do not match.",
    registerSuccess: "Registration successful! You can now log in.",
    registerError: "Registration failed. Please check your input.",
    backToLogin: "Back to Login",
    resetPasswordTitle: "Reset Password",
    resetPasswordWelcome1Error:
      'Using the "Welcome1" password is not allowed, please choose another.',
    resetPasswordMismatch:
      "The two passwords do not match, please check again.",
    resetPasswordSameAsPrevious:
      "The new password cannot be the same as the previous password.",
    resetPasswordSuccess:
      "Password changed successfully. Redirecting to login…",
    resetPasswordError: "An error occurred, please try again later.",
    resetPasswordSubmit: "Save Password",
    newPassword: "New password",
    newPasswordPlaceholder: "Enter new password",
    repeatPasswordPlaceholder: "Enter new password again",
    saving: "Saving…",
    millingsListTitle: "Millings list",
    millingNameRequired: "Name is required.",
    millingNamePlaceholder: "e.g. groove milling",
    millingSaveError: "Save error.",
    noData: "No data",
    tableLabel: "Table",
    filterAll: "Full list",
    colorSwapFailed: "Color swap failed. Please try again.",
    addItemFailed: "Could not add new item, please try again.",
    generatingInProgress: "Generating in progress...",
    generateAlreadyOptimal: "Already optimal result.",
    generateSuccess: "Generation successful.",
    saveChangesTitle: "Save changes",
    saveChangesBeforeGenerate:
      "There are unsaved changes. Save them before generating?",
    saveAndGenerate: "Save & Generate",
    noTablesYet: "No tables yet, generate first",
    addTableFailed: "Could not add new table.",
    deleteTableConfirm:
      "Are you sure you want to delete this table and its items?",
    saveChangesConfirm: "Are you sure you want to save the changes?",
    rotateFailed: "Rotation not possible, no free space.",
    unsavedChangesBody: "There are unsaved changes. Save before continuing?",
    saveAndContinue: "Save & Continue",
    discardChanges: "Discard & Continue",
    editBtn: "Edit",
    exportBtn: "Export",
    generateBtn: "Generate",
    addTable: "Add table",
    deleteTable: "Delete table",
    moveToTable: "Move to:",
    rotateTable: "Rotate table",
    bgOff: "Background off",
    bgOn: "Background on",
    detailsOff: "Details off",
    detailsOn: "Details on",
    linesOff: "Lines off",
    linesOn: "Lines on",
    tableId: "Table ID",
    unknownId: "Unknown ID",
    noTableSelected: "No table selected",
    currentTable: "Current table",
    avgUsage: "Average usage",
    partCount: "Part count",
    measureCount: "Dimension count",
    kantTotal: "Total edge",
    usage: "Usage",
    noSize: "No size",
    posX: "Right-Left",
    posY: "Up-Down",
    posZ: "Forward-Back",
    rotX: "Forward-Back",
    rotY: "Horizontal",
    rotZ: "Sideways",
    snapInfo: "Furniture alignment",
    snapToFurniture: "Align furniture to furniture",
    snapToWall: "Align furniture to wall",
    snapSelect1: "1. select furniture",
    snapSelect2: "2. select target",
    shortcuts: "Shortcuts",
    shortcutMeasure: "Measure mode",
    shortcutMoveRotate: "Move / Rotate",
    shortcutSnap: "Snapping on/off",
    shortcutSelectSnap: "Selection snap",
    shortcutInfo: "Info panel",
    shortcutEscape: "Exit / reset",
    shortcutSizeLabels: "Size labels",
    drag: "drag",
    measureMode: "Measure mode",
    measureSelectPoint: "Select point",
    measureFinish: "Finish",
    moveMode: "Move",
    vertical: "Vertical",
    horizontal: "Horizontal",
    rotateMode: "Rotate",
    tilt: "Tilt",
    roomSizeMm: "Room dimensions (mm)",
    measureTotal: "Total distance",
    measureX: "Width distance (X)",
    measureY: "Height distance (Y)",
    measureZ: "Depth distance (Z)",
    info: "Information",
    moveAndRotate: "Move and rotate",
    move: "Move",
    snapOff: "Snapping off.",
    snapOn: "Snapping on.",
    apply: "Apply",
    saveConfigPrompt: "Enter a name for the settings:",
    selectScript: "Select script",
    back: "Back",
    saveFurniture: "Save furniture",
    selectRoom: "Select room",
    selectRoomPlaceholder: "-- Select a room --",
    originalSettings: "Original settings",
    saveSettings: "Save settings",
    generalSettings: "General settings",
    settingsOf: "settings",
    addNewSize: "Add new size",
    employeeTitle: "Employees",
    addEmployee: "Add employee",
    usersTitle: "Users",
    addUser: "Add user",
    worksTitle: "Works",
    workName: "Workname",
    createNewScript: "Create new script",
    scriptImage: "Script image",
    scriptNamePlaceholder: "Script name",
    room: "Room",
    imageAfterSaveHint: "No plan image has been uploaded.",
    changeImage: "Add or change image",
    saveScript: "Save plan",
    confirmCloseScript: "Are you sure you want to close the plan?",
    referencedScriptSettings: "Referenced script settings",
    referenceScript: "Reference script",
    defaultValue: "Default value",
    addSetting: "Add setting",
    settingsListTitle: "Settings",
    settingsValue: "Settings value",
    noWorks: "No work created yet",
    orderId: "Id",
    paidAmmount: "Paid ammount",
    totalAmmount: "Total price",
    paidAmount: "Paid amount",
    totalAmount: "Total amount",
    labor: "Labor",
    editClient: "Edit client",
    newWork: "New work",
    workCount: "Work count",
    activeWorks: "Active works",
    completedWorks: "Completed works",
    remainingPayment: "Remaining payment",
    previousWorks: "Previous works",
    clientWorks: " works",
    selectMilling: "Select milling",
    table: "Table",
    noTable: "No table",
    usedSheets: "Used sheets",
    cutLength: "Cut length",
    work: "Work",
    milling: "Milling",
    ammount: "Ammount",
    settingsAdd: "Add setting",
    deleteSelected: "Delete selected",
    noItemsForFilter: "No items for this filter",
    userWorksTitle: "Works",
    unsavedChangesTitle: "Unsaved changes",
    line: "line",
    errorNoClient: "Error, no client selected",
    Unauthorized: "Unauthorized",
    Error: "Error",
    deleteItemConfirm: "Are you sure you want to delete this item?",
    deleteUser: "Delete user",
    noOrdersFromUser: "This user has no orders.",
    deleteUserConfirm: "Are you sure you want to delete this user?",
    deleteSelectedConfirm:
      "Are you sure you want to delete the selected items?",
    sizeListBtn: "Item list",
    trim: "Trim",
    direction: "Direction",
    both: "Both",
    fullTable: "Full Table",
    halfTable: "Half Table",
    allowHalfTable: "Allow Half Table",
    disallowHalfTable: "Disallow Half Table",
    selectTableFirst: "Select a table before placing an item",
    placeItem: "Place item",
    cancelPlacement: "Cancel placement selection",
    placeInWaste: "Place item in waste area",
    lengthwise: "Lengthwise",
    crosswise: "Crosswise",
    enableRotation: "Enable item rotation",
    enableRotationConfirm:
      "This item is currently not rotatable. Are you sure you want to enable rotation and place it vertically?",
    confirmRotation: "Yes, enable rotation",
    selectedItemMissing: "The selected item can no longer be found.",
    invalidItemQuantity: "The item quantity must be greater than zero.",
    itemAlreadyFullyPlaced:
      "All instances of the item are already placed on a table.",
    invalidItemSize: "The item size is invalid, so it cannot be placed.",
    tableColorMissing: "No color is assigned to the selected table.",
    itemColorMismatch:
      "The item color does not match the selected table color.",
    rotationConfirmationRequired:
      "This item cannot be rotated. Select vertical placement again and confirm that rotation may be enabled.",
    itemDoesNotFitVertical:
      "The selected item does not fit vertically in this remaining area.",
    itemDoesNotFitHorizontal:
      "The selected item does not fit horizontally in this remaining area.",
    datiOrderFailed: "The data order for the new item could not be determined.",
    datiWriteFailed: "The item could not be added to the table data.",
    itemPlacedVerticalRemaining:
      "The item was placed vertically. {{count}} more pieces can be placed.",
    itemPlacedHorizontalRemaining:
      "The item was placed horizontally. {{count}} more pieces can be placed.",
    allItemsPlacedVertical: "All instances of the item were placed vertically.",
    allItemsPlacedHorizontal:
      "All instances of the item were placed horizontally.",
    itemPlacedReplayFailedRemaining:
      "The item was placed, but the table could not be updated. {{count}} more pieces can be placed.",
    itemPlacedReplayFailed:
      "The item was placed, but the affected table could not be updated.",
    stableDatiLinkMissing:
      "The position has no reliable data link, so deletion was stopped for safety.",
    riferimentiRenumberFailed: "The references cannot be renumbered safely.",
    righeRenumberFailed: "The cutting lines cannot be renumbered safely.",
    righeAbsRenumberFailed:
      "The absolute cutting lines cannot be renumbered safely.",
    invalidNewTableSize: "The new table size is invalid.",
    currentTableColorMissing: "The current table color could not be found.",
    invalidTrim: "The trim value is invalid.",
    halfTableAdded: "The half table was added.",
    fullTableAdded: "The full table was added.",
    newTableSizeMissing: "The new table size is not specified.",
    invalidFullTableSize:
      "The full table size assigned to the color is invalid.",
    tableMarkedForDeletion:
      "The table was marked for deletion. Its items were removed from it but kept.",
    deletePosition: "Delete position",
    previousColor: "Previous color",
    nextColor: "Next color",
    previousTable: "Previous table",
    nextTable: "Next table",
    newTableSettings: "New table settings",
    trimHelp:
      "This value defines the starting point and size of the usable area on an empty table.",
    cutOrientation: "Cut direction",
    placementSelectionCancelled: "The placement selection was cancelled.",
    placementHintVertical:
      "Click a suitable remaining area to place the item vertically.",
    placementHintHorizontal:
      "Click a suitable remaining area to place the item horizontally.",
    sizeListGenerated: "The size list was generated successfully.",
    sizeListUnsavedChanges:
      "The size list cannot be generated because there are unsaved changes.",
    sizeListNoTables:
      "The size list cannot be generated because no table has been created.",
    sizeListSaveRequired:
      "All changes must be saved before generating the size list.",
    sizeListItemsUnplaced:
      "The size list cannot be generated because not all items are placed on tables.",
    noChangesToSave: "There are no changes to save.",
    showMilling: "Show milling"
  }
};

export default common;
